/* eslint-disable func-names */
/* eslint-disable no-undef */

import { debounce } from "../helpers/helpers";

const nav = () => {
  (function ($) {
    const $window = $(window);
    const $accordionHeader = $(".js-accordion-header");
    const $accordionPanel = $(".js-accordion-panel");
    const $secondaryLink = $(".js-nav-secondary-link");
    const $secondaryBack = $(".js-nav-secondary-back");
    const $secondaryLinkDesktop = $(
      '[data-menu-level="1"] .js-nav-secondary-link'
    );
    const $secondarySubNav = $('[data-menu-level="1"] .js-accordion-panel');
    const $navDrawer = $(".c-navigation__drawer");
    const $tertiaryLink = $(".js-accordion-link");

    const openClass = "open";
    const accordionIconOpen = "o-accordion-icon--open";
    const accordionHeaderOpen = "o-accordion-header--open";
    const accordionHeaderOpenLevel0 = "o-accordion-header--level-0--open";
    const accordionHeaderLevel2 = "o-accordion-header--level-2";
    const listActive = "c-navigation__list--nested--active";
    const isMobileTablet = $window.width() < 1024;

    $accordionHeader.css('pointer-events', 'auto');
    $secondaryLink.css('pointer-events', 'auto');
    $tertiaryLink.css('pointer-events', 'auto');

    $accordionHeader.on("click", function (e) {
      e.preventDefault();
      const $this = $(this);
      const isPanelOpen = $this.next().hasClass(listActive);

      if (isMobileTablet) {
        $this.toggleClass(accordionHeaderOpen);
        $this.children().toggleClass(accordionIconOpen);
        $this.next().slideToggle();
        return;
      }

      if (isPanelOpen) {
        $this.next().removeClass(listActive);
        $accordionHeader.removeClass(accordionHeaderOpenLevel0);
        $navDrawer.css("height", "0");
        return;
      }

      $accordionHeader.removeClass(accordionHeaderOpenLevel0);
      $accordionPanel.removeClass(listActive);
      $accordionPanel.removeAttr("style");
      $accordionPanel.removeClass(openClass);
      $this.next().toggleClass(listActive);
      $this.addClass(accordionHeaderOpenLevel0);
      $secondaryLink.removeClass(openClass);

      const isOurLocations = $this.attr("title") === "Our Locations";

      if (isOurLocations) {
        // reset drawer height
        $navDrawer.removeAttr("style");
        return;
      }

      const subNavHeight = $this.next().outerHeight();
      $navDrawer.css("height", subNavHeight);
    });

    // open secondary mobile / tablet portrait
    $secondaryLink.on("click", (e) => {
      e.preventDefault();
      const $target = $(e.target);
      const $secondaryMenu = $target.next();
      const isOpen = $secondaryMenu.hasClass(openClass);

      if (isMobileTablet) {
        if (!isOpen) {
          $secondaryMenu.addClass(openClass);
        }
      }
    });

    // open secondary desktop
    $secondaryLinkDesktop.on("click", (e) => {
      e.preventDefault();
      const $target = $(e.target);
      const $secondaryMenu = $target.next();
      const isLevel3 = $target.hasClass(accordionHeaderLevel2);
      const elementPosition = $target.offset();
      const elementWidth = $target.outerWidth();
      const subNavPosition = elementPosition.left + elementWidth;

      // get height of first level subnav
      const subNavHeight = $target.parent().parent().outerHeight();
      $secondaryMenu.removeAttr("style");

      if (!isMobileTablet) {
        // third level menu
        if (isLevel3) {
          $("[data-menu-level='2'] .js-nav-secondary-link.open").removeClass(
            openClass
          );
          $("[data-menu-level='2'] .js-accordion-panel.open").removeClass(
            openClass
          );
          $target.addClass(openClass);
          $secondaryMenu.addClass(openClass);
          const parentHeight = $target.parent().parent().outerHeight();
          $secondaryMenu.css("min-height", parentHeight);
          $secondaryMenu.css({
            "min-height": subNavHeight,
            left: subNavPosition,
          });

          $accordionPanel.each(function () {
            $(this).attr("data-height", $(this).outerHeight());
          });

          const tertiaryMenuHeight = $secondaryMenu.data("height");

          if (tertiaryMenuHeight > subNavHeight) {
            $target.parent().parent().css("height", tertiaryMenuHeight);
            $navDrawer.css("height", tertiaryMenuHeight);
            return;
          }

          return;
        }

        $secondaryLinkDesktop.removeClass(openClass);
        $secondarySubNav.removeClass(openClass);
        $target.addClass(openClass);
        $secondaryMenu.addClass(openClass);

        $accordionPanel.each(function () {
          $(this).attr("data-height", $(this).outerHeight());
        });

        const secondaryMenuHeight = $secondaryMenu.data("height");

        $secondaryMenu.css("left", subNavPosition);

        if (secondaryMenuHeight > subNavHeight) {
          $navDrawer.css("height", secondaryMenuHeight);
          return;
        }
        $navDrawer.css("height", subNavHeight);
        $secondaryMenu.css("min-height", subNavHeight);
      }
    });

    // close secondary
    $secondaryBack.on("click", (e) => {
      const $target = $(e.target);

      $target.closest(".js-accordion-panel").removeClass(openClass);
    });

    const windowResize = () => {
      $accordionPanel.removeAttr("style");
      $accordionHeader.removeClass(accordionHeaderOpen);
      $accordionHeader.removeClass(accordionHeaderOpenLevel0);
      $accordionHeader.children().removeClass(accordionIconOpen);
      $accordionPanel.removeClass(listActive);
    };

    const dHandler = debounce(100, windowResize);
    $(window).resize(dHandler);
  })(jQuery);
};

export default nav;
